import script from "./STDSDC05C03UpdateAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./STDSDC05C03UpdateAccount.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__